<template>
  <div id="addProjectModal" >
    <ul class="tabs drag-handle">
      <li class="tab" @click="showTab='project'">
        <a :class="{active: showTab == 'project'}">{{projectId == null? "Create" : "Update"}} {{ project && project.sensorId}} Project</a></li>
      <li  v-if="project && project.sensorId == 'CAM'"  @click="showTab='setting'" class="tab"><a :class="{active: showTab =='setting'}">Project Settings</a></li>
      <li  v-if="project && project.id != null"  @click="showTab='user'" class="tab"><a :class="{active: showTab =='user'}">User Assignment</a></li>

      <div @click="close" class="iconButton link">
        <span class="ion-close"></span>
      </div>
    </ul>
    <div v-if="project != null">
      <div class="modal-content padded40" v-show="showTab =='project'">
        <div class="row">
          <div class="col s12 m6 l8">
            <label for="project_title">Project Title</label>
            <input id="project_title" v-model="project.fullNm" type="text" class="validate" required placeholder="Project Title">
          </div>
          <div class="col s12 m6 l4">
            <label for="project_title">Organization
              <span class="info-icon ion-information-circled"
                v-tooltip="`The organization you are collecting data on behalf of.`"/>
            </label>
            <select v-model="project.organizationId" :disabled="project.id > 0">
              <template v-for="(option, index) in organizationList">
              <option v-if="project.id > 0" :key="'org' + index" :value="option.id">{{option.organization}}</option>
              <option v-if="project.id == null && option.canEditOrganization" :key="'org' + index" :value="option.id">{{option.organization}}</option>
              </template>
            </select>
          </div>
          <div class="col s12 m4">
            <label for="project_year">Year</label>
            <input id="project_year" type="text" class="validate" v-model.number="project.year">
          </div>
          <div v-if="project.sensorId !== 'PC'" class="col s12 m4 l4">
            <label>Due Date</label>
            <div class="vue-select-wrapper">
              <datepicker v-model="project.dueDateStr" format="yyyy-MM-dd" :use-utc="true" :disabled-dates="state.disabledDates"></datepicker>
            </div>
          </div>
          <div class="col s12 m4">
            <label for="project_dataSource">Data Source
              <span class="info-icon ion-information-circled"
                v-tooltip="`If data is being imported into WildTrax, please specify the data source.`"/>
            </label>
            <input id="project_dataSource" type="text" class="validate" v-model.number="project.dataSource">
          </div>
          <!-- <div class="col s12 m6 l4">
            <label>Project Type</label>
            <div>{{activeSensor}}</div>
          </div> -->
          <div class="col s12 m6 l4" v-if="false">
            <label>Storage Location  <span class="info-icon ion-information-circled" v-tooltip="tooltips.storage" /></label>
            <div class="vue-select-wrapper">
              <select v-model="project.defaultStorageId">
                <option value=""> -- </option>
                <option v-for="(option, index) in options.storage" :key="index" :value="option.id">{{option.displayName}}</option>
              </select>
            </div>
          </div>
          <div class="col s12 ">
            <label for="project_description" >Description</label>
            <textarea id="project_description" class="materialize-textarea" data-length="120" v-model="project.description"></textarea>
            <span class="character-counter" style="float: right; font-size: 12px; height: 1px;"></span>
          </div>
          <div class="col s12 m4 l4">
            <label>Status</label>
            <div class="vue-select-wrapper">
              <select class="initialized" v-model="project.status" type="number">
                <template  v-for="(option, index) in options.status">
                  <!-- dont show published map + report for pc, its the same as published public as they have no media -->
                  <option v-if="!(project.sensorId === 'PC' && option.id === 4)" :key="index" :value="option.id">{{option.type}}</option>
                </template>
              </select>
            </div>
          </div>
          <!-- div class="col s12 m6 l6">
            <label>Processing Method</label>
            <div class="vue-select-wrapper">
              <select class="initialized" v-model="project.method" type="number">
                <option v-for="(option, index) in options.method" :key="index" :value="option.id">{{option.type}}</option>
              </select>
            </div>
          </div-->
        </div>
        <div v-for="(error,index) in errors" v-bind:key="index" class="error"> {{error}} </div>
        <div class="modal-footer">
          <button class="btn btn-success modal-trigger modal-action modal-close" id="projectSave" @click="saveProject">
            <template>Save</template>
          </button>
          <button class="btn btn-border modal-action modal-close" id="cancelAdd" @click="close">Close</button>
        </div>
      </div>
      <!-- add users -->
      <div class="modal-content padded40" v-show="project.id != null && showTab =='user'">
        <h5>Add User to Project</h5>
        <div class="row">
          <div class="col s12 m4 l4">
            <label>Available Users</label>
            <div class="vue-select-wrapper">
              <multiselect v-model="selectedUser"
                placeholder="search user" label="name" track-by="id" :options="userOptionList" :multiple="false">
              </multiselect>
              <!-- <select class="initialized" v-model="selectedUser">
                <option v-for="(option, index) in usersNotInProject" :key="index" :value="{id:option.user.id, name:option.user.name}">{{option.user.name}}</option>
              </select> -->
            </div>
          </div>
          <div class="col s12 m2 l2">
            <div v-tooltip ="tooltips.admin"><button class="btn" @click="addUser(true, 'insert')" text="Add as Admin">Add as Admin</button></div>
            <div v-tooltip ="tooltips.readAccess"><button  class="btn" @click="addUser(false, 'insert')" text="Add with Read Access">Add with Read Access</button></div>
          </div>
          <div class="col s12 m6 l6">
            <label>Assigned Users</label>
            <div class="vue-select-wrapper">
              <ul>
                <template v-for="(option, index) in userGrantedList" :value="option.user.id" >
                  <li v-if="option.admin" class="admin" :key="'admin' + index">
                  {{option.user.name}} <span v-if="option.admin">(Admin)</span> <span v-if="!option.isMe" class="ion-android-delete" @click="removeUser(option)"></span>
                  </li>
                </template>
                <template v-for="(option, index) in userGrantedList" :value="option.user.id">
                  <li v-if="!option.admin" :key="'user' + index" >
                    {{option.user.name}} <span v-if="!option.admin">(Read Access)</span> <span v-if="!option.isMe" class="ion-android-delete" @click="removeUser(option)"></span>
                    </li>
                </template>

              </ul>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="message">{{message}}</div>
          <button class="btn btn-border modal-action modal-close" id="cancelAdd" @click="close">Close</button>
        </div>
      </div>
      <!-- project settings -->
      <div class="modal-content padded40" v-show="showTab =='setting' && project.sensorId == 'CAM'">
        <div class="row">
            <h6>Pre-processing Image Tools</h6>
            <div class="col s12">
              <div class="col s12 l4 bottom-margin">
                <label for="auto-tagger">
                  <input id="auto-tagger" v-model="project.useAutoTagger" type="checkbox">
                  <span/>
                  Auto Tagger (COW, NONE)
                  <span class="info-icon ion-information-circled" v-tooltip ="'An AI tool which uses a combination of Microsoft MegaDetector to detect Human / Vehicles / False Fires / Animals and a Wildtrax AI to further detect cows and enhance human detection. Cows + False Fires will be hidden to save you time undone in the image set filter options.'"></span>
                </label>
              </div>
              <div class="col s12 l4 bottom-margin">
                <label for="auto-staff">
                  <input id="auto-staff" v-model="project.useStaffSetupAutoTag" type="checkbox">
                  <span/>
                  Staff/Setup Tagger
                  <span class="info-icon ion-information-circled" v-tooltip ="'Takes the first and last groupings of images and tags them as staff if the AI detects multiple humans at that point.'"></span>
                </label>
              </div>
              <div class="col s12 l4 bottom-margin">
                <label for="second-image-gap">
                  Time (sec) Between Images
                  <span class="info-icon ion-information-circled" v-tooltip ="'Select the default series gap you want to use. You can change this setting later in the Series View tab.'"/>
                  <input id="second-image-gap" v-model="project.seriesGap" type="input">
                </label>
              </div>
          </div>
        </div>
        <div v-for="(error,index) in errors" v-bind:key="index" class="error"> {{error}} </div>
        <div class="modal-footer">
          <button class="btn btn-success modal-trigger modal-action modal-close" @click="saveProject">Save</button>
          <button class="btn btn-border modal-action modal-close" @click="close">Close</button>
        </div>
      </div>
    </div>
    <div v-if="loading" class="center" style="padding:40px;">
        <pulse-loader :loading="true" color="#C94412" size="15px" :width="60" :height="30"></pulse-loader>
        <div>{{commonMsg.loading}}</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'; // required for tooltip
import Datepicker from 'vuejs-datepicker';
import {eventBus} from '@/lib/eventbus';
import {API_URL, alertDialog} from '@/lib/common';
import { VTooltip } from 'v-tooltip';
import Multiselect from '@/components/utils/vue-multiselect/src/Multiselect';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue' // spinner for loading
import FormMixin from '@/components/common/FormMixin.js';
Vue.directive('tooltip', VTooltip)

export default {
  name: 'project-form',
  props: ['projectId', 'activeSensor', 'options'],
  components: {Datepicker, 'multiselect': Multiselect, 'pulse-loader': PulseLoader},
  mixins: [FormMixin],
  data () {
    return {
      url: API_URL + 'get-project-details',
      projectUpdateUrl: API_URL + 'insert-update-project',
      listOrgUrl: API_URL + 'get-organization-summary',
      organizationList: [],
      formName: 'project',
      project: null,
      loading: true,
      usersNotInProject: [],
      usersInProject: [],
      recordingName: 'Project',
      message: '',
      selectedUser: null,
      showTab: 'project',
      errors: [],
      userOptionList: [],
      userGrantedList: [],
      doesDeploymentExistInProject: true, // if unknown use 1 so not able to edit,
      state: {
        disabledDates: {
        }
      },
      // localVisibility: null,
      tooltips: {
        'storage': `Please select the most applicable Amazon s3 storage location for your data. Oregon is the nearest Amazon s3 storage location to Edmonton (default),
        while Montreal is the nearest Canadian Amazon s3 storage location.
        If you would like your data to remain within Canada, please select the Montreal option.`,
        'admin': `Add as Admin: Admins have read/write access to the entire project. They are able to edit a project, add users, assign tasks, and edit transcriber/tagger work.`,
        'readAccess': `Add with Read Access: Users can see all tasks/deployments and buffered locations associated with a project. They cannot make any edits unless assigned as transcriber/tagger on a specific task/deployment.`
      }
    }
  },
  async created () {
    await this.loadProject(this.projectId);
    await this.loadOrganization();
    this.loading = false;
    let date = new Date();
    date.setDate(date.getDate() - 1);
    this.state.disabledDates.to = date;
  },
  watch: {
    projectId: function (newVal, oldVal) {
      if (newVal !== -1) {
        this.switchProject();
      }
    },
    usersNotInProject: function () {
      this.userOptionList = [];
      this.usersNotInProject.map(x => this.userOptionList.push({id: x.user.id, name: x.user.name}));
      this.userOptionList.sort(function (a, b) {
        return (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1);
      });
    },
    usersInProject: function () {
      this.userGrantedList = [];
      this.usersInProject.map(x => this.userGrantedList.push(x));
      this.userGrantedList.sort(function (a, b) {
        return (a.user.name.toUpperCase() < b.user.name.toUpperCase() ? -1 : 1);
      });
    }
  },
  methods: {
    /* not used after we move organization into separte page
    addOrganizationOption (newTag) {
      if (!newTag) {
        return;
      }
      // remove previously added value
      this.options.dataSet = this.options.dataSet.filter(x => x.id > 0);

      const tag = {
        name: newTag.toUpperCase(),
        id: -1
      }
      this.options.dataSet.splice(0, 0, tag);
      Vue.set(this.project, 'dataSet', tag); /* !!!important, use Vue.set instead of = to assign, otherwise, binding won't update *
    },
    */
    switchProject () {
      this.showTab = 'project';
      // console.log('projectId =', this.projectId, this.project.id)
      if (this.projectId !== null && this.projectId > 0) {
        if (this.projectId !== this.project.id) { // only clear messages when project id are different.
          this.errors = [];
        }
        this.loadProject(this.projectId); // need to reload to get user lists
      } else {
        this.errors = [];
        this.initProject();
      }
    },
    initProject () {
      this.project = {
        useAutoTagger: true,
        seriesGap: 120,
        sensorId: this.activeSensor,
        useStaffSetupAutoTag: true,
        defaultStorageId: 2,
        // shortNm: 'xx',
        //   visibility: 2,
        status: 2
      };
      this.doesDeploymentExistInProject = false;
    },
    async loadOrganization () {
      await this.$http.get(this.listOrgUrl).then(
        function (response) {
          if (!response.data || response.data.hasOwnProperty.call('error')) {
            this.organizationList = [];
          } else {
            this.organizationList = response.data.results;
          }
        }
      );
    },
    async loadProject (projectId) {
      if (projectId) { // get projectId from database if id is provided.
        await this.$http.get(this.url, {params: {sensor: this.activeSensor, projectId: projectId}}).then(
          function (response) {
            if (response.body.error || response.data.error) {
              alertDialog(this.$modal, 'Error', this.commonMsg.deny.view);
              this.close();
            } else {
              this.project = response.data.project;
              this.usersNotInProject = response.data.usersNotInProject;
              this.usersInProject = response.data.usersInProject;
              this.doesDeploymentExistInProject = (response.data.doesDeploymentExistInProject != null ? response.data.doesDeploymentExistInProject : true);
              this.project.sensorId = this.activeSensor;

              if (!this.project.defaultStorage && this.project.sensorId === 'CAM') {
                this.project.defaultStorage = {};
              }
              //   this.localVisibility = this.project.visibility;
            }
          },
          function (error) {
            alertDialog(this.$modal, 'Error', this.commonMsg.deny.view + error.body);
            this.close();
          }
        );
      } else {
        this.initProject();
        //      this.localVisibility = this.project.visibility;
      }
    },
    close () {
      this.errors = [];
      this.message = '';
      this.showTab = 'project';
      eventBus.$emit('close-project-form');
      this.$modal.hide('project');
    },
    async saveProject () {
      /* validation */
      this.errors = [];
      if (!this.project.fullNm) {
        this.errors.push('Project Name required.');
      }

      if (!this.project.organizationId) {
        this.errors.push('Project Organization required.');
      }
      // if (!this.project.defaultStorageId) {
      //   this.errors.push('Project defaultStorage required.');
      // }

      if (!this.project.year) {
        this.errors.push('Project year required.');
      } else if (this.project.year < 1990) {
        this.errors.push('Project year needs to be later than 1990.');
      }

      if (this.errors.length > 0) {
        return;
      }
      const self = this;
      this.project.sensorId = this.activeSensor;
      this.commonInsertUpdate(this.projectUpdateUrl, this.project, (this.projectId > 0 ? 'update' : 'add'), function (response) {
        self.project = response.data;
        if (!self.projectId > 0) {
          self.errors = ['New project added successfully. Please assign users or close.'];
        }
        eventBus.$emit('reload-table');
        eventBus.$emit('reload-project-form', response.data.id);
        eventBus.$emit('load-project-info');
      });
    },
    addUser (asAdmin, action) {
      if (this.project.id != null && this.selectedUser != null) {
        const newUser = {
          user: { id: this.selectedUser.id,
            name: this.selectedUser.name
          },
          admin: asAdmin

        };
        const params = {
          projectId: this.project.id,
          users: [ newUser ],
          action: action
        };
        this.message = '';
        this.$http.post(API_URL + 'alter-project-users', params).then(
          function (response) {
            if (response.data.hasOwnProperty.call('error')) {
              this.errors.push('failed to add user ' + response.data.error);
            } else {
              this.usersInProject.push(newUser);
              for (let i = this.usersNotInProject.length - 1; i >= 0; i--) {
                if (this.usersNotInProject[i].user.id === this.selectedUser.id) {
                  this.usersNotInProject.splice(i, 1);
                }
              }
              this.message = 'User added';
              eventBus.$emit('load-project-user');
            }
          });
      }
    },
    removeUser (option) {
      if (this.project.id != null) {
        if (!confirm('You are about to remove ' + option.user.name + ' from this project')) {
          return;
        }
        const params = {
          projectId: this.project.id,
          users: [ option ],
          action: 'delete'
        };
        this.message = '';
        this.$http.post(API_URL + 'alter-project-users', params).then(
          function (response) {
            if (response.data.hasOwnProperty.call('error')) {
              this.errors.push('Failed to remove user ' + response.data.error);
            } else {
              this.usersNotInProject.push(option);
              for (let i = this.usersInProject.length - 1; i >= 0; i--) {
                if (this.usersInProject[i].user.id === option.user.id) {
                  this.usersInProject.splice(i, 1);
                  // break;
                }
              }
              this.message = 'User removed';
              eventBus.$emit('load-project-user');
            }
            // alert(response.data.result);
          });
      }
    }
  }
}
</script>
<style>

.bottom-margin{
  margin-bottom: 20px;
}

</style>
